<template>
  <div>
    <gj-table
        ref="gjTable"
        name="saleHotRank"
        :index="false"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :adapt-height="false"
        :height="534"
        row-id="id"
        :tree-config="{transform: false, lazy: true, hasChild: 'hasChild',loadMethod: loadChildrenMethod}"
    >

      <template v-slot:header:asin>
        <span v-if="type === 'asin'">ASIN</span>
        <span v-if="type === 'variationAsin'">父ASIN/子ASIN</span>
        <span v-if="type === 'msku'">MSKU</span>
      </template>

      <template v-slot:index="{row,index}">
        {{rank(row,index)}}
      </template>

<!--      <template v-slot:header:product>-->
<!--        <app-dashboard-rank-product-header :type="type"></app-dashboard-rank-product-header>-->
<!--      </template>-->
<!--      -->
<!--      <template v-slot:product="{ row }">-->
<!--        <app-dashboard-rank-product-column-->
<!--            :type="type"-->
<!--            :row="row">-->
<!--        </app-dashboard-rank-product-column>-->
<!--      </template>-->

      <template v-slot:picture="{row}">
        <app-dashboard-rank-picture-column
            :row="row"
            :groupType="type"
        ></app-dashboard-rank-picture-column>
      </template>

      <template v-slot:asin="{row}">
        <template v-if="type !== 'msku'">
          <gj-link v-if="row.hasChild" :href="row.variationAsinUrl" target="_blank">{{row.variationAsin | defaultShow}}</gj-link>
          <gj-link v-else :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
        </template>
        <span v-else>{{row.msku | defaultShow}}</span>
      </template>

      <template v-slot:inventoryQuantity="{row}">
        <gj-popover-panel
            :title="'FBA库龄明细'"
            :width="'200px'"
            :data="[
              {label: '0~30', value: row.invAge0To30Days || 0},
              {label: '31~60', value: row.invAge31To60Days || 0},
              {label: '61~90', value: row.invAge61To90Days || 0},
              {label: '91~180', value: row.day90To180Quantity || 0},
              {label: '181~270', value: row.day180To270Quantity || 0},
              {label: '271~365', value: row.day270To365Quantity || 0},
              {label: '365+', value: row.day365MoreQuantity || 0},
            ]"
            placement="right">
          {{row.inventoryQuantity | defaultShow}}
        </gj-popover-panel>
      </template>

      <template v-slot:inventoryFbmQuantity="{row}">
        <gj-popover-panel
            :title="'FBM库龄明细'"
            :width="'200px'"
            :data="[
              {label: '0~30', value: row.day0To30QuantityFbm || 0},
              {label: '31~60', value: row.day31To60QuantityFbm || 0},
              {label: '61~90', value: row.day61To90QuantityFbm || 0},
              {label: '91~180', value: row.day90To180QuantityFbm || 0},
              {label: '181~270', value: row.day180To270QuantityFbm || 0},
              {label: '271~365', value: row.day270To365QuantityFbm || 0},
              {label: '365+', value: row.day365MoreQuantityFbm || 0},
            ]"
            placement="right">
          {{row.inventoryFbmQuantity | defaultShow}}
        </gj-popover-panel>
      </template>

      <template v-slot:availableDays="{row}">
        <span class="colorGreen">{{row.availableDays | defaultShow}}</span>
      </template>

      <template #empty v-if="!showStoreMask">
        <div></div>
      </template>

    </gj-table>
  </div>
</template>

<script>
  import {queryMixin} from "../../../../../../minxins";
  import {getSaleHotRank, getSaleLowRank} from "../../../../../../api/dashboard";
  import AppDashboardRankProductHeader from "./components/dashboard-rank-product-header";
  import AppDashboardRankProductColumn from "./components/dashboard-rank-product-column";
  import AppDashboardRankPictureColumn from "./components/dashboard-rank-picture-column";
  import {rankMixin} from "@/views/modules/home/components/rank/components/mixin";

  export default {
    name: "app-dashboard-sale-low-rank",
    components: {AppDashboardRankPictureColumn, AppDashboardRankProductColumn, AppDashboardRankProductHeader},
    mixins: [queryMixin, rankMixin],
    data() {
      return {
        rankName: 'saleLow',
        tableData: [],
        columns: [
          {id: 'index', header: '排名', field: 'slot:index', width: '60px'},
          {id: 'picture', header: '图片', field: 'slot:picture', width: '50px'},
          {id: 'listingTitle', header: '商品标题', field: 'listingTitle', minWidth: '300px', overflowLine: 2},
          {id: 'asin', header: 'slot:asin', field: 'slot:asin', width: '140px'},
          // {id: 'product', header: 'slot:product', field: 'slot:product', minWidth: '300px'},
          {id: 'sale', header: '7天销量', field: 'saleQuantity', width: '70px', align: 'right', sortable: false},
          {id: 'sales', header: '7天销售额', field: 'sales', prefix: 'currencySymbol', align: 'right', width: '110px', sortable: false},
          // {id: 'return', header: '7天退款量', field: 'refundQuantity', align: 'right', width: '90px', sortable: false},
          // {id: 'fba', header: 'FBA库存', field: 'slot:inventoryQuantity', align: 'right', width: '80px', sortable: false},
          {id: 'fba', header: 'FBA可售', field: 'slot:inventoryQuantity', align: 'right', width: '80px', sortable: false},
          {id: 'inventoryFbmQuantity', header: 'FBM可售', field: 'slot:inventoryFbmQuantity', align: 'right', width: '80px', sortable: false},
          {id: 'saleableAmount', header: '可售货值', field: 'saleableAmount', prefix: 'currencySymbol', align: 'right', width: '90px', sortable: false},
          {id: 'unsalableQuantity', header: '滞销量', field: 'unsalableQuantity', align: 'right', width: '90px'},
          // {id: 'saleDays', header: '可售周转', field: 'availableDays', align: 'right', width: '75px', sortable: false},
          {id: 'saleDays', header: 'FBA可售周转', field: 'slot:availableDays', align: 'right', width: '100px', sortable: false},
          {id: 'availableDaysFbm', header: 'FBM可售周转', field: 'availableDaysFbm', align: 'right', width: '100px', sortable: false},
        ],
      }
    },
    methods: {
      //异步获取父asin展开数据
      loadChildrenMethod ({ row }) {
        return getSaleLowRank({
          currency: this.dashboardCurrency,
          groupType: 'asin',
          month:this.month,
          variationAsin: row.variationAsin,
          marketIds: row.marketId
        })
      },
      $gjQuery() {
        if(!this.showStoreMask){
          return
        }
        // 查询
        this.loading = true;
        getSaleLowRank({
          currency: this.dashboardCurrency,
          groupType: this.type,
          month:this.month,
          countrys: this.countryMarket.countryIds.join(','),// 国家
          marketIds: this.countryMarket.marketIds.join(','),// 店铺
        })
          .then((data) => {
            this.tableData = data;
            if(this.type === 'variationAsin'){
              this.tableData.forEach((r,index)=>{
                r.hasChild = true;
              })
            }
          })
          .complete(() => this.loading = false);
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "common";
  /deep/ .el-icon-arrow-down {
    font-weight: bold;
  }
  /deep/ .vxe-table--render-default .vxe-cell{
    padding-left: 10px;
  }
</style>



